import React, { useContext } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import routesConfig from '../../../../modules/routesConfig';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import VerticalNavGroup from './VerticalNavGroup';
import { checkPermission } from "@crema/utility/Utils";
import AppContext from '@crema/utility/AppContext';
import { useAuthToken } from '@crema/utility/AppHooks';
import {matchRoutes} from 'react-router-config';
import { ThemeMode, Fonts } from '../../../../shared/constants/AppEnums';

const useAiNavStyles = makeStyles((theme) => ({
  navItem: {
    height: 40,
    marginTop: 2,
    marginBottom: 2,
    cursor: 'pointer',
    textDecoration: 'none !important',
    width: 'calc(100% - 16px)',
    borderRadius: '0 30px 30px 0',
    paddingLeft: 24,
    paddingRight: 12,
    '&:hover, &:focus': {
      '& .nav-item-text': {
        color: (props) =>
          props.themeMode === ThemeMode.LIGHT
            ? theme.palette.primary.main
            : '#fff',
      },
      '& .nav-item-icon': {
        color: (props) =>
          props.themeMode === ThemeMode.LIGHT
            ? theme.palette.primary.main
            : '#fff',
      },
    },
    '& .nav-item-icon': {
      color: theme.palette.sidebar.textColor,
    },
    '& .nav-item-text': {
      color: theme.palette.sidebar.textColor,
      fontWeight: Fonts.MEDIUM,
    },
  },
  listIcon: {
    fontSize: 18,
  },
}));

const Navigation = () => { 

  const {pathname, search} = useLocation();
  const { routes, themeMode } = useContext(AppContext);
  const [loading, user] = useAuthToken(); 
  const currentRoute = matchRoutes(routes, pathname)[0].route;
  let routesConfigCopy = [...routesConfig];
  const aiClasses = useAiNavStyles({ themeMode });

  const hermesPort = user && user.hermes_port && parseInt(user.hermes_port) > 0
    ? parseInt(user.hermes_port)
    : null;
 
  return (
    <List>
      {routesConfigCopy.map((item) => {

            // console.log(item, item?.type);
            let isAllow = checkPermission( (pathname === "/permission-denied" || pathname === "/signin") ? ['su','manager','sales','data_entry','company_size'] : currentRoute.auth, user ? user.role : null, user ? user.permissions: null, { path: item?.url ? item?.url : "" });
            if (item?.type === 'collapse') {
                let childrens = item?.children?.filter((itm) => {
                                                                  let isChildrenAllowed = checkPermission((pathname === "/permission-denied") ? ['su','manager','sales','data_entry','company_size'] : currentRoute.auth, user ? user?.role : null, user ? user?.permissions: null, { path: itm?.url ? itm?.url : "" });
                                                                  if(isChildrenAllowed){
                                                                    return itm;
                                                                  } else {
                                                                    return false;
                                                                  }
                                                              });               
                item.children = childrens;
            }

            //console.log(isAllow, item);
            // console.log(item?.type, isAllow, item?.url);
            return (<React.Fragment key={item.id}>

                      {item.type === 'group' && <VerticalNavGroup item={item} level={0} />}

                      { ( item.type === 'collapse' && item.children?.length > 0 ) && (
                        <VerticalCollapse item={item} level={0} />
                      )}

                      { (item.type === 'item' && isAllow === true) && <VerticalItem item={item} level={0} />}

                    </React.Fragment>
                  )
          }
      
      )}

      {hermesPort && (
        <ListItem
          button
          component='a'
          href={`https://hermes.lead411.com:${hermesPort}/`}
          target='_blank'
          rel='noopener noreferrer'
          className={clsx(aiClasses.navItem, 'nav-item')}>
          <Box component='span' mr={6}>
            <Icon
              className={clsx(aiClasses.listIcon, 'nav-item-icon')}
              color='action'>
              psychology
            </Icon>
          </Box>
          <ListItemText
            primary='Hermes AI'
            classes={{primary: 'nav-item-text'}}
          />
        </ListItem>
      )}
    </List>
  );
};

export default Navigation;
